import React, { useEffect } from "react";
import { Button, Tab, Tabs } from "@material-ui/core";
import TicketCardDetails from "./TicketCardDetails";
import TicketModalDetails from "./TicketModalDetails";
import { useHistory } from "react-router-dom";
import { actions } from "../../../../SearchPage/_redux/searchRedux";
import { useDispatch } from "../../../../../utils/react-redux-hooks";
import { useSelector } from "react-redux";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { getTravelDetails } from "../../../../SearchPage/_redux/searchCrud";
import { useMediaQuery } from "react-responsive";
import { getTravelStations } from "./cruds";
import ReactLoading from "react-loading";
import ResImg from "../../../../../../ebusHomePics/Reasult.png";
import moment from "moment-jalaali";
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';

const TravelInfoCard = (props) => {
  const [openOrClose, setOpenOrClose] = React.useState(-1);
  const [display, setDisplay] = React.useState({});
  const [tabsValue, setTabsValues] = React.useState({});
  const [open, setOpen] = React.useState({});
  const [isContentsLoading, setIsContentsLoading] = React.useState(false);

  const state = useSelector((state) => state.reserve);

  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const history = useHistory();
  const dispatch = useDispatch();

  const isTimeToTravel = (dateTime) => { // true => if time is less than now
    console.log("dateTime", dateTime)
    console.log("moment(dateTime)", moment(dateTime))
    console.log("moment()", moment().format("YYYY-MM-DDTHH:mm:ss"))
    console.log("moment(dateTime).isBefore(moment())", moment(dateTime).isBefore(moment()))
    return moment(dateTime).isBefore(moment())
  }

  const ticketSelector = (id, price) => {
    if (props.props.date2) {
      history.push(
        `/bus-ticket-reverse/${props.props.source_id}/${props.props.dest_id}/${props.props.date2},${props.props.date}/${id}/${props.props.count}`
      );
    } else if (!props.date2) {
      history.push(
        `/bus-ticket-reverse/${props.props.source_id}/${props.props.dest_id}/${props.props.date}/${id}/${props.props.count}`
      );
    }
    console.log("price", price)
    dispatch(actions.setDynamicPrice(price));
    dispatch(actions.props(props.props));
  };

  const bgcHandler = (gender, isNewReserved) => {
    if (gender && !isNewReserved) {
      return "#cecaca";
    } else if (gender && isNewReserved) {
      return "rgb(167, 255, 167)";
    } else {
      return "white";
    }
  };

  const colorAndBorderHandler = (gender, isNewReserved, color) => {
    if (gender && !isNewReserved) {
      return "darkgray";
    } else if (gender && isNewReserved) {
      return "green";
    } else {
      return color;
    }
  };

  const seatStyleSetter = (seatClass, gender, isNewReserved) => {
    if (seatClass) {
      switch (seatClass) {
        case 1:
          return {
            color: colorAndBorderHandler(gender, isNewReserved, "orange"),
            border: `2px solid  ${colorAndBorderHandler(
              gender,
              isNewReserved,
              "orange"
            )}`,
            width: "35px",
            height: "35px",
            backgroundColor: bgcHandler(gender, isNewReserved),
            marginInline: "1px",
          };
        case 2:
          return {
            color: colorAndBorderHandler(gender, isNewReserved, "gray"),
            border: `2px solid  ${colorAndBorderHandler(
              gender,
              isNewReserved,
              "darkgray"
            )}`,

            width: "35px",
            height: "35px",
            backgroundColor: bgcHandler(gender, isNewReserved),
            marginInline: "1px",
          };
        case 3:
          return {
            color: colorAndBorderHandler(gender, isNewReserved, "black"),
            border: `2px solid  ${colorAndBorderHandler(
              gender,
              isNewReserved,
              "black"
            )}`,
            width: "35px",
            height: "35px",
            backgroundColor: bgcHandler(gender, isNewReserved),
            marginInline: "1px",
          };
      }
    } else {
      return {
        color: "white",
        border: "2px solid white",
        width: "35px",
        height: "35px",
        backgroundColor: bgcHandler(gender, isNewReserved),
        marginInline: "1px",
      };
    }
  };

  const genderTitleSetter = (id, seatNum) => {
    switch (id) {
      case 0:
        return (
          <h6 className="mx-auto my-auto" style={{ fontSize: "100%" }}>
            خانم
          </h6>
        );
      case 1:
        return (
          <h6 className="mx-auto my-auto" style={{ fontSize: "100%" }}>
            آقا
          </h6>
        );
      // case 2:
      //   return (
      //     <h6 className="mx-auto my-auto" style={{ fontSize: "100%" }}>
      //       کودک
      //     </h6>
      //   );
      default:
        return (
          <h6 className="mx-auto my-auto" style={{ fontSize: "100%" }}>
            {seatNum}
          </h6>
        );
    }
  };

  const seatValidation = (obj) => {
    return (
      <div
        className={`${!isMobile ? "col-3 px-5" : "col-3 px-1"} ${+obj.rowId === 0 ? "d-none" : "d-flex"
          }`}
        style={{ transform: "rotate(90deg)", transformOrigin: "40% 40%" }}
      >
        <div
          className="d-flex justify-content-center align-items-center rounded"
          type="button"
          style={seatStyleSetter(
            obj.carSeatId,
            obj.isReserved,
            obj.isNewReserved
          )}
        >
          {obj.isReserved
            ? genderTitleSetter(obj.gender, obj.seatNumber)
            : obj.seatNumber}
        </div>
      </div>
    );
  };

  const TabsSituationHandler = (label, travelId, el) => {

    if (label === "نقشه صندلی ها") {
      // if (openOrClose == 0) {
      //   const copy = tabsValue;
      //   delete copy[el.travelId].value;
      //   setTabsValues(copy);
      //   return "";
      // } else
      return (
        <div className="d-flex flex-column">
          <div className="row flex-column" style={{ height: "30rem" }}>
            <div
              className="col-6 mx-auto"
              style={{
                transform: "rotate(-90deg)",
                transformOrigin: "27% 40%",
                marginTop: "10%",
              }}
            >
              <div
                className="bg-white w-100 container-fluid pt-7 p-2"
                style={{
                  height: "40rem",
                  borderRadius: 20,
                  border: "1px solid darkgray",
                }}
              >
                <div
                  className="d-flex h-auto flex-wrap "
                  style={{ minHeight: "100%" }}
                >
                  {tabsValue[travelId]?.data
                    ? tabsValue[travelId]?.data.carDetails.carSchemaInfo.map(
                      (el, index) => {
                        return seatValidation(el);
                      }
                    )
                    : null}
                </div>
              </div>
            </div>
          </div>
          <h6
            className="mx-auto my-auto"
            style={{ cursor: "pointer" }}
            onClick={() => {
              const copy = tabsValue;
              delete copy[travelId].value;
              setTabsValues(copy);
            }}
          >
            بستن
          </h6>
        </div>
      );
    } else if (label === "جزییات مسیر") {
      // if (openOrClose == 0) {
      // const copy = tabsValue;
      // delete copy[el.travelId].value;
      // setTabsValues(copy);
      // return "";
      // } else
      return (
        <div className="d-flex flex-column">
          <div
            className="row h-auto justify-content-start container"
            style={{ paddingBlock: "3.3rem" }}
          >
            <div className="col-sm-6 d-block">
              <div className="d-flex" style={{ gap: 10 }}>
                <div className="d-flex flex-column justify-content-between">
                  <h5 style={{ fontSize: "20px" }}>
                    {timeManager(el.departureDatetime)}
                  </h5>
                  <h5 style={{ fontSize: "20px" }}>
                    {timeManager(el.arrivedTime)}
                  </h5>
                </div>
                <div>
                  <i className="far fa-circle" style={{ color: "darkgray" }}>
                    <div
                      className="connect-line h-auto"
                      style={{
                        marginInline: "7px",
                        minHeight: "10rem",
                        borderRight: "1px solid darkgray",
                      }}
                    ></div>
                    <i
                      className="fa fa-circle"
                      style={{ color: "darkgray" }}
                    ></i>
                  </i>
                </div>
                <div className="d-flex flex-column justify-content-between">
                  <h4>
                    <b>{el.directionSourceTitle}</b>
                  </h4>
                  <h2 className="d-flex flex-column">
                    {tabsValue[travelId].stations &&
                      tabsValue[travelId].stations.map((el, idx) => {
                        return (
                          <p className="my-3" style={{ fontSize: "13px" }}>
                            {el.stationTitle}
                          </p>
                        );
                      })}
                  </h2>
                  <h4>
                    <b>{el.directionDestTitle}</b>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <p
            style={{ fontSize: "14px", cursor: "pointer" }}
            onClick={() => {
              const copy = tabsValue;
              delete copy[travelId].value;
              setTabsValues(copy);
            }}
            className="mx-auto my-auto"
          >
            بستن
          </p>
        </div>
      );
    }
    else if (label === "قوانین جریمه و استرداد") {
      // if (openOrClose == 0) {
      //   const copy = tabsValue;
      //   delete copy[el.travelId].value;
      //   setTabsValues(copy);
      //   return "";
      // } else
      return (
        <div
          className="d-flex flex-column flex-wrap mt-5 pt-5 px-5"
          style={{ gap: "15px" }}
        >
          <h6>
            هزینه کنسلی از زمان خرید بلیط تا یک ساعت قبل از حرکت:{" "}
            <b>۱۰ درصد قیمت بلیط</b>
          </h6>
          <h6>
            کمتر از یک ساعت مانده به حرکت و بعد از آن:{" "}
            <b>۵۰ درصد قیمت بلیط</b>
          </h6>
          <p
            style={{ fontSize: "14px", cursor: "pointer" }}
            onClick={() => {
              const copy = tabsValue;
              delete copy[travelId].value;
              setTabsValues(copy);
            }}
            className="mx-auto my-auto"
          >
            بستن
          </p>
        </div>
      );
    }
    else {
      return "";
    }
  };

  const timeManager = (time) => {
    if (time) {
      const splittedTime = time
        .split("T")[1]
        .split(".")[0]
        .split(":");
      return `${splittedTime[0]}:${splittedTime[1]}`;
    }
  };

  const jsxreturner = () => {
    const condition = state.loadingStats;
    switch (condition) {
      case "0":
        return (
          <div className="col-12 d-flex  flex-column justify-content-center align-items-center">
            <img
              src={ResImg}
              style={{ objectFit: "contain", height: "25rem" }}
              className="w-100"
              alt="no-ticket"
            />
            <h4>متاسفانه اتوبوسی یافت نشد</h4>
          </div>
        );
      case undefined:
        return (
          <SkeletonTheme baseColor="#e7e8ea" highlightColor="#d4cdcd">
            <Skeleton
              count={5}
              style={{ height: "10rem", marginBlock: 10, borderRadius: "12px" }}
            />
          </SkeletonTheme>
        );
      case "-1":
        return "خطایی در دریافت اطلاعات یافت شد";
    }
  };

  // useEffect(() => {
  //   if (openOrClose == 0) {
  //     console.log("close tab")
  //   }
  // }, [openOrClose])

  // const handleOpenCloseTab = () => {
  //   if (openOrClose == -1 || openOrClose == 0)
  //     setOpenOrClose(1)
  //   if (openOrClose == 1)
  //     setOpenOrClose(0)
  // }

  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <div>
      {props.data.length !== 0
        ? props.data.map((el) => {
          return (
            <div
              className="mt-5  rad15 dg1-border shdow-sm bg-white p-3"
              style={{
                marginBottom: "2.75rem",
                boxShadow: "0px 0px 10px lightgray",
              }}
            >
              <div
                className="d-md-flex d-sm-block p-2"
                style={{ minHeight: 150 }}
              >
                <div className="col-sm-12 col-md-9 d-flex flex-column justify-content-between p-0">
                  <div className="container row">
                    <div className="col-4 col-md-2">
                      <h3
                        className="my-auto"
                        style={{ opacity: "0.85", fontSize: "23px", fontWeight: "bold", textAlign: "left" }}
                      >
                        {el.ridingTime
                          ? timeManager(el.ridingTime)
                          : "دریافت نشد"}
                      </h3>
                    </div>
                    <div className="d-flex col-8 col-md-10" style={{ gap: "10px" }}>
                      <h2
                        className="my-auto"
                        style={{ opacity: "0.85", fontSize: "20px" }}
                      >
                        {el.directionSourceTitle
                          ? `${el.directionSourceTitle}`
                          : "دریافت نشد"}
                      </h2>
                      <div
                        className="line mx-auto"
                        style={{ marginBottom: "auto", width: "85%" }}
                      ></div>

                      <h2
                        className="my-auto"
                        style={{ opacity: "0.85", fontSize: "20px" }}
                      >
                        {el.directionDestTitle
                          ? `${el.directionDestTitle}`
                          : "دریافت نشد"}
                      </h2>
                    </div>
                    <div className="col-4 col-md-2" style={{ gap: "10px" }}></div>
                    <div className="d-flex justify-content-between  col-9 col-sm-9 ml-25 ml-sm-0 col-md-10 pt-1">
                      <h6 style={{ opacity: "0.7", fontSize: "14px" }}>
                        {el.srcCompany
                          ? `${el.srcCompany?.terminalName}`
                          : ""}
                      </h6>
                      <h6 style={{ opacity: "0.7", fontSize: "14px" }}>
                        {" "}
                        {el.destCompany
                          ? `${el.destCompany?.terminalName}`
                          : ""}

                      </h6>
                    </div>
                  </div>
                  {!isMobile && (
                    <>
                      <div style={{ marginTop: "4rem" }}>
                        <Tabs
                          value={tabsValue[el.travelId]?.value}
                          style={{ display: isMobile ? "none" : "flex" }}
                          onChange={async (e, a) => {
                            // handleOpenCloseTab();

                            if (tabsValue[el.travelId]) {
                              const copy = tabsValue;
                              copy[el.travelId].value = a;

                              setTabsValues(copy);
                            } else if (!tabsValue[el.travelId]) {
                              const copy = tabsValue;
                              copy[el.travelId] = {};
                              copy[el.travelId].value = a;
                              const srcId = window.localStorage.getItem(
                                "srcId"
                              );
                              const destId = window.localStorage.getItem(
                                "destId"
                              );
                              if (!tabsValue[el.travelId]?.stations) {
                                setIsContentsLoading(true);
                                const copy = tabsValue;
                                const params = { travelId: el.travelId };
                                await getTravelStations(params).then(
                                  (res) => {
                                    const arr = [];
                                    for (
                                      let i = 1;
                                      i < res.data.data.length - 1;
                                      i++
                                    ) {
                                      arr.push(res.data.data[i]);
                                    }

                                    copy[el.travelId].stations = arr;
                                    setTabsValues(copy);
                                  }
                                );
                              }

                              await getTravelDetails(
                                srcId,
                                destId,
                                el.travelId
                              ).then((res) => {
                                res.data.data.fullSeats.map((el) => {
                                  const index = res.data.data.carDetails.carSchemaInfo.findIndex(
                                    (le) => {
                                      return le.seatNumber === el.seatNumber;
                                    }
                                  );
                                  res.data.data.carDetails.carSchemaInfo[
                                    index
                                  ].isReserved = true;
                                  res.data.data.carDetails.carSchemaInfo[
                                    index
                                  ].gender = el.gender;
                                });
                                copy[el.travelId].data = res.data.data;
                              });
                              setTabsValues(copy);
                            }
                            setIsContentsLoading(false);
                          }
                          }
                          aria-label="simple tabs example"
                        >
                          <Tab
                            style={{ fontSize: "16px" }}
                            {...a11yProps(0)}
                            label={
                              <span style={{ fontSize: "14px" }}>
                                نقشه صندلی ها
                              </span>
                            }
                            value="نقشه صندلی ها"
                          />
                          <Tab
                            {...a11yProps(1)}
                            label={
                              <span style={{ fontSize: "14px" }}>
                                جزییات مسیر
                              </span>
                            }
                            value="جزییات مسیر"
                          />
                          <Tab
                            {...a11yProps(2)}
                            label={
                              <span style={{ fontSize: "14px" }}>
                                قوانین جریمه و استرداد
                              </span>
                            }
                            value="قوانین جریمه و استرداد"
                          />
                        </Tabs>
                      </div>
                      {isContentsLoading ? (
                        <div
                          className="bg-white row justify-content-center"
                          style={{ height: "6rem", marginTop: "2rem" }}
                        >
                          <ReactLoading
                            type={"spin"}
                            color={"green"}
                            height={"12%"}
                            width={"12%"}
                          />
                        </div>
                      ) : (
                        <>
                          {TabsSituationHandler(
                            tabsValue[el.travelId]?.value,
                            el.travelId,
                            el
                          )}
                        </>
                      )}
                    </>
                  )}
                  <div
                    className="col-12 d-md-none d-flex px-5 justify-content-between"
                    style={{ marginBlock: "10% 5%" }}
                  >
                    <h4 className="my-auto d-flex" style={{ gap: "5px" }}>
                      ظرفیت موجود:
                      <span
                        style={{
                          color: el.emptySeatCount < 10 ? "red" : "#6dd06d",
                        }}
                      >
                        {el.emptySeatCount || +el.emptySeatCount === 0
                          ? `${el.emptySeatCount} نفر`
                          : "دریافت نشد"}
                      </span>
                    </h4>
                    <h4 className="my-auto">
                      <span style={{ opacity: "0.75", color: "#6dd06d" }}>
                        <b>
                          {el.dynamicPrice ? el.dynamicPrice.toLocaleString('ar-EG') : "دریافت نشد"}
                        </b>
                      </span>
                      <span style={{ fontSize: 15, marginRight: 5 }}>
                        ریال
                      </span>
                    </h4>
                  </div>
                  <div className="col-12 d-md-none p-0">
                    <Button
                      className="btn w-100 col-12 p-3 align-items-center"
                      style={{
                        backgroundColor: "#6dd06d",
                        whiteSpace: "nowrap",
                        borderRadius: "12px",
                        height: "3.5em",
                      }}
                      onClick={() => {
                        // ticketSelector(el.travelId, el.basePrice);
                        ticketSelector(el.travelId, el.dynamicPrice);
                      }}
                    >
                      <h5 className="my-auto text-white">
                        <b>انتخاب صندلی</b>
                      </h5>
                    </Button>
                  </div>
                </div>
                <div
                  className="col-sm-12 col-md-3 d-none d-md-block"
                  style={{ marginTop: 2 }}
                >
                  <div className="row flex-column">
                    <div
                      className="text-dark text-center mx-auto mb-6"
                      style={{ fontSize: "20px" }}
                    >
                      <div style={{ opacity: "0.75" }}>
                        <div>
                          <b>{el.dynamicPrice ? el.dynamicPrice.toLocaleString('ar-EG') : "دریافت نشد"}</b>
                          <span
                            style={{ opacity: 0.5, fontSize: 15, marginRight: 5 }}
                          >
                            ریال
                          </span>
                        </div>
                        <div>
                          <span
                            className="white-nowrap"
                            style={{
                              whiteSpace: "nowrap",
                              textDecoration: "line-through",
                              textDecorationColor: "red"
                            }}
                          >
                            {el.basePrice ? el.basePrice.toLocaleString('ar-EG') : "دریافت نشد"}
                          </span>
                          <span
                            style={{ opacity: 0.5, fontSize: 15, marginRight: 5 }}
                          >
                            ریال
                          </span>
                        </div>
                      </div>

                    </div>
                    <div
                      style={{ gap: 10 }}
                      className="mx-auto d-flex col-12 flex-column"
                    >
                      {" "}
                      <span
                        className="mx-auto text-center my-2"
                        style={{ opacity: 0.5, fontSize: 14 }}
                      >
                        ظرفیت موجود:
                        {el.emptySeatCount || +el.emptySeatCount === 0
                          ? el.emptySeatCount
                          : "دریافت نشد"}
                      </span>
                      <div>
                        <Button
                          className="btn col-12 w-100 p-3"
                          style={{
                            backgroundColor: "#6dd06d",
                            whiteSpace: "nowrap",
                            borderRadius: "12px",
                            height: "3.9em",
                          }}
                          disabled={el.emptySeatCount === 0}
                          // disabled={isTimeToTravel(el.departureDatetime) ? true : false}
                          onClick={() => {
                            // ticketSelector(el.travelId, el.basePrice);
                            ticketSelector(el.travelId, el.dynamicPrice);
                          }}
                        >
                          <h5 className="my-auto text-white">
                            <b>انتخاب صندلی</b>
                          </h5>
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <TicketModalDetails
                ticketId={el.travelId}
                ticketSelector={ticketSelector}
                ridingTime={
                  el.ridingTime ? timeManager(el.ridingTime) : "دریافت نشد"
                }
                arrivedTime={
                  el.arrivedTime ? timeManager(el.arrivedTime) : "دریافت نشد"
                }
                emptySeatCount={
                  el.emptySeatCount || +el.emptySeatCount === 0
                    ? el.emptySeatCount
                    : "دریافت نشد"
                }
                directionSourceTitle={
                  el.directionSourceTitle
                    ? `ترمینال ${el.directionSourceTitle}`
                    : "دریافت نشد"
                }
                directionDestTitle={
                  el.directionDestTitle
                    ? `ترمینال ${el.directionDestTitle}`
                    : "دریافت نشد"
                }
                basePrice={el.basePrice ? el.basePrice : "دریافت نشد"}
                open={open}
                setOpen={setOpen}
              />
              <TicketCardDetails
                travelId={el.id ? el.id : null}
                ridingTime={
                  el.ridingTime ? timeManager(el.ridingTime) : "دریافت نشد"
                }
                arrivedTime={
                  el.arrivedTime ? timeManager(el.arrivedTime) : "دریافت نشد"
                }
                emptySeatCount={
                  el.emptySeatCount || +el.emptySeatCount === 0
                    ? el.emptySeatCount
                    : "دریافت نشد"
                }
                directionSourceTitle={
                  el.srcCompany
                    ? ` ${el.srcCompany.terminalName}`
                    : "دریافت نشد"
                }
                directionDestTitle={
                  el.destCompany
                    ? ` ${el.destCompany.terminalName}`
                    : "دریافت نشد"
                }
                basePrice={el.basePrice ? el.basePrice : "دریافت نشد"}
                display={display[el.id]}
              />
            </div>
          );
        })
        : jsxreturner()}
    </div>
  );
};

export default TravelInfoCard;
